import {
  PrimaryButton,
  pxTovW,
  pxToRem,
  IconWrapper,
  IStyles,
  theme,
  useCommonServiceClientContext,
  getLocalStorage,
  getDifficultyLevelString,
  ImageWrapper,
  Loader,
  NoContentCard,
  deserify,
  ActionPopUpSingleButton,
  ReminderPopup,
  InputField,
  getMediaBasePath,
} from '@geneo2-web/shared-ui';
import {
  Box,
  Button,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
} from '@mui/material';
import {
  useAppDispatch,
  useAppSelector,
} from '../../../../reduxStore/reduxHooks';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { PaperDetailsCard } from '../components/PaperDetailsCard';
import { useEffect, useRef, useState } from 'react';
import { ProfileRolesEnum } from '@protos/user_management/ums.db_pb';
import {
  setQPGContent,
  setQPGFormatDetails,
} from '../../reducer/assessmentFlow.slice';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { getSubjectNameFromEnum } from '../../../Home/home.utils';
import {
  ASSESMENT_LIBRARY,
  HOME,
  HOMEWORK_MANAGE,
  QPG_ASSESSMENT_PUBLISH,
  QPG_PREVIEW,
} from '../../../../routeHandling/RoutesNomenclature';
import QPGPrintablePaper from '../QPGPreview/component/QPGPrintablePaper';
import {
  TaskCreationStatusEnum,
  TaskEnum,
} from '@protos/learning_management/lms.db_pb';
import {
  buildTaskInfoModels,
  getSubjectColorBySubjectId,
  getSubjectImageBySubjectId,
  getTotalMarksOfSection,
} from '../QPGv2.utils';
import { setToastInfoV2 } from '../../../Home/reducer/homeDashboard.slice';
import { ConnectError } from '@bufbuild/connect';
import { useGlobalContext } from '../../../../app/Context/GlobalContextProvider';
import { useWhiteLabeledUrl } from 'apps/teacher/src/utils/customHooks';

const styles: IStyles = {
  root: {
    paddingX: { xs: pxToRem(20), md: pxTovW(50), lg: pxTovW(240) },
    paddingY: { xs: pxToRem(20), md: pxTovW(50) },
    backgroundColor: '#f8f7fc',
    minHeight: '100vh',
  },
  mainHeadingBox: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'unset', md: 'center' },
    marginBottom: { xs: pxToRem(20), md: pxTovW(40) },
    gap: { xs: pxToRem(10), md: pxTovW(50) },
  },
  ellipsisText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    wordBreak: 'break-word',
    paddingBottom: { xs: pxToRem(3), md: pxTovW(5) },
    width: { xs: 'unset', md: '60%' },
  },
  previewBox: {
    backgroundColor: '#FFF6D4',
    border: '2px solid #F8C807',
    borderRadius: { xs: pxToRem(5), md: pxTovW(10) },
    cursor: 'pointer',
    boxSizing: 'border-box',
    width: { xs: pxToRem(28), md: pxTovW(70), lg: pxTovW(50) },
    height: { xs: pxToRem(28), md: pxTovW(70), lg: pxTovW(50) },
    // display: { xs: 'none', md: 'flex' },
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
  },
  viewAndPdfBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(30) },
    ml: { xs: 'unset', md: 'auto' },
  },
  viewLibraryButton: {
    background: '#C1F8DA',
    display: 'flex',
    borderRadius: { xs: pxToRem(6), md: pxTovW(10) },
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #0AA34F',
    padding: {
      xs: pxToRem(7),
      md: `${pxTovW(16)} ${pxTovW(23)}`,
      lg: `${pxTovW(13)} ${pxTovW(20)}`,
    },
    gap: { xs: pxToRem(5), md: pxTovW(16) },
  },
  downloadPdfButton: {
    background: '#CFEAFF',
    display: 'flex',
    borderRadius: { xs: pxToRem(6), md: pxTovW(10) },
    boxSizing: 'border-box',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #007CDC',
    padding: {
      xs: pxToRem(7),
      md: `${pxTovW(16)} ${pxTovW(23)}`,
      lg: `${pxTovW(13)} ${pxTovW(25)}`,
    },
    gap: { xs: pxToRem(5), md: pxTovW(16) },
  },
  settingsbox: {
    backgroundColor: '#CFEAFF',
    border: '2px solid #007CDC',
    borderRadius: { xs: pxToRem(5), md: pxTovW(10) },
    cursor: 'pointer',
    boxSizing: 'border-box',
    width: { xs: pxToRem(28), md: pxTovW(70), lg: pxTovW(50) },
    height: { xs: pxToRem(28), md: pxTovW(70), lg: pxTovW(50) },
    // display: { xs: 'none', md: 'flex' },
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
  },
  publishedCreateCopyBox: {
    backgroundColor: '#DBFFEB',
    border: '2px solid #3BEA8A',
    borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingX: { xs: pxToRem(10), md: pxTovW(15) },
    paddingY: { xs: pxToRem(5), md: pxTovW(8) },
    marginBottom: { xs: pxToRem(20), md: pxTovW(40) },
  },
  publishedAndNoteBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(5), md: pxTovW(5) },
  },
  publishedBox: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(8), md: pxTovW(8) },
  },
  createCopyButton: {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(5), md: pxTovW(6) },
    width: { xs: pxToRem(87), md: pxTovW(220), lg: pxTovW(145) },
    height: { xs: pxToRem(24), md: pxTovW(75), lg: pxTovW(42) },
    padding: { xs: pxToRem(5), md: pxTovW(10) },
    borderRadius: { xs: pxToRem(5), md: pxTovW(7) },
    boxShadow: 'none',
  },
  menu: {
    marginTop: { xs: pxToRem(10), md: pxTovW(20) },
    '& .MuiMenu-list': {
      // width: { xs: pxToRem(200), md: pxTovW(210) },
      width: '100%',
      borderRadius: pxTovW(10),
      boxShadow: `0 0 ${pxTovW(10)} #00000038`,
      padding: 0,
    },
    '& .MuiMenu-paper': {
      borderRadius: pxTovW(10),
    },
  },
  menuItem: {
    borderBottom: '1px solid #D2D2D2',
    padding: { xs: pxToRem(10), md: pxTovW(10) },
    '&:last-child': {
      borderBottom: '1px solid transparent',
    },
    '&:hover': {
      backgroundColor: '#F2F2F2',
      borderBottom: '1px solid transparent',
      borderRadius: 0,
    },
  },
  secondaryHeadingBox: {
    display: 'flex',
    justifyContent: { xs: 'space-between', md: 'unset' },
    alignItems: 'center',
    gap: { xs: pxToRem(10), md: pxTovW(25) },
    marginBottom: { xs: pxToRem(20), md: pxTovW(25) },
  },
  classNamePill: {
    border: '1px solid #5DACF7',
    backgroundColor: '#DDFAEC',
    borderRadius: { xs: pxToRem(25), md: pxTovW(25) },
    paddingX: { xs: pxToRem(5), md: pxTovW(25) },
    paddingY: { xs: pxToRem(5), md: pxTovW(10) },
  },
  cardsBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: { xs: pxToRem(10), md: pxTovW(30) },
  },
  helperText: {
    bgcolor: '#FFDFDF',
    color: 'error.main',
    mt: pxToRem(4),
    padding: { xs: pxToRem(10), md: `${pxTovW(12)} ${pxTovW(30)}` },
  },
};

export const QPGPublished = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const teacherId = getLocalStorage('userId');
  const [searchParams] = useSearchParams();
  const assessmentId = searchParams.get('assessment_id');
  const { setSelectedFunction } = useGlobalContext();
  const {
    LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler,
    LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler,
  } = useCommonServiceClientContext();
  const { user_info } = deserify(useAppSelector((state) => state.auth));
  const { qpg_content, qpg_format_details } = deserify(
    useAppSelector((state) => state.assessment)
  );

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [loading, setLoading] = useState<'loading' | 'success' | 'error'>(
    'success'
  );

  // --------------- Printables -------------------

  const [printAnswer, setPrintAnswer] = useState<boolean>(false);
  const [printFontSize, setPrintFontSize] = useState<number>(16);
  const [addFontSizePopup, setAddFontSizePopup] = useState<boolean>(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const printablePaperRef = useRef<any>(null);

  // ----------------------------------------------------
  const school_logo_url = useWhiteLabeledUrl();
  console.log('school_logo_url:', school_logo_url);
  const viewLibraryHandler = () => {
    navigate(ASSESMENT_LIBRARY);
  };

  // ----------------------------------------------------

  const handleMenuClick = async (
    event:
      | React.MouseEvent<HTMLButtonElement>
      | React.MouseEvent<HTMLImageElement, MouseEvent>
      | React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    {
      name: 'Download Question Paper',
      onClick: async () => {
        setPrintAnswer(false);
        setIsDownloading(true);
        setTimeout(async () => {
          try {
            await printablePaperRef.current?.handlePrint(false);
          } finally {
            setIsDownloading(false);
          }
        }, 0);
      },
    },
    {
      name: 'Download Answer Paper',
      onClick: async () => {
        setPrintAnswer(true);
        setIsDownloading(true);
        setTimeout(async () => {
          try {
            await printablePaperRef.current?.handlePrint(true);
          } finally {
            setIsDownloading(false);
          }
        }, 0);
      },
    },
    {
      name: 'Download Both',
      onClick: async () => {
        setPrintAnswer(false);
        setIsDownloading(true);
        setTimeout(async () => {
          try {
            await printablePaperRef.current?.handlePrint(false);
            setPrintAnswer(true);
            await printablePaperRef.current?.handlePrint(true);
          } finally {
            setIsDownloading(false);
          }
        }, 0);
      },
    },
  ];

  // ----------------------------------------------------

  const createCopyHandler = async () => {
    let metaInfo = qpg_content?.multiSubjectSections ?? [];
    try {
      setLoading('loading');
      const assessmentCreationSubmitResponse =
        await LmsAssessmentTeacherAPIServiceV6WithStatusCodeHandler.assessmentCreationSubmit(
          {
            sourceGeneoAssessmentId: Number(
              qpg_content?.assessment?.assessmentId
            ),
            teacherId: BigInt(teacherId),
            classId: qpg_content?.assessment?.classId,
            creationStatus: TaskCreationStatusEnum.TASK_CREATION_STATUS_DRAFT,
            multiSubjectSectionMetaInfo: metaInfo,
            sectionId: qpg_content?.assessment?.sectionId,
            subjectIds: metaInfo?.map((section) => section.subjectId) ?? [],
            taskName: qpg_content?.assessment?.assessmentTitle + ' (Copy)',
            taskType: TaskEnum.TASK_MULTI_SUBJECT_QUESTION_PAPER_CUSTOM,
            instructions: qpg_content?.assessment?.assessmentInstructions,
            questionModuleMap:
              qpg_content?.questionsSequenceInfo?.questionModuleMap,
            selectedTasksInfo: buildTaskInfoModels(metaInfo),
            chapterIdsInfo:
              qpg_content?.assessment?.taskMetaInfo?.chapterInfo
                ?.chapterTopicsInfo,
          }
        );

      if (assessmentCreationSubmitResponse.status === 200) {
        navigate(
          `${QPG_ASSESSMENT_PUBLISH}?assessment_id=${assessmentCreationSubmitResponse.data?.assessment?.assessmentId}`
        );
      } else {
        dispatch(
          setToastInfoV2({
            label: 'Error while creating a copy of Question Paper',
            variant: 'error',
            open: true,
          })
        );
      }
      setLoading('success');
    } catch (error) {
      setLoading('success');
      console.log('error:', error);
      let message = 'Error while creating a copy of Question Paper';
      if (error instanceof ConnectError) {
        message = error.rawMessage?.replace(/.*\]\s*/, '').trim();
      }
      dispatch(
        setToastInfoV2({
          label: message,
          variant: 'error',
          open: true,
        })
      );
    }
  };

  // ----------------------------------------------------

  const fetchAssessmentContent = async () => {
    try {
      setLoading('loading');
      const fetchAssessmentContentResponse =
        await LmsAssessmentCommonAPIServiceV1ClientWithStatusCodeHandler.fetchAssessmentContent(
          {
            personId: teacherId,
            personType: ProfileRolesEnum.PROFILE_ROLE_TEACHER,
            assessmentId: Number(assessmentId),
          }
        );

      if (fetchAssessmentContentResponse.data) {
        setLoading('success');
        dispatch(setQPGContent(fetchAssessmentContentResponse.data));

        const selectedSubjectsAndMarks =
          fetchAssessmentContentResponse.data?.multiSubjectSections?.map(
            (item) => ({
              subject:
                item.subjectId != null
                  ? {
                      name: getSubjectNameFromEnum(item.subject),
                      id: item.subjectId,
                    }
                  : null,
              marks: item.preferredMarks,
            })
          ) ?? [];

        dispatch(
          setQPGFormatDetails({
            ...qpg_format_details,
            ...(fetchAssessmentContentResponse.data?.assessment?.classId !=
              null && {
              selectedClass: {
                name: `Class ${fetchAssessmentContentResponse.data?.assessment?.class}`,
                id: fetchAssessmentContentResponse.data?.assessment.classId,
              },
            }),
            selectedSubjectsAndMarks: selectedSubjectsAndMarks,
            assessmentName:
              fetchAssessmentContentResponse.data?.assessment
                ?.assessmentTitle ?? '',
          })
        );
      } else {
        setLoading('error');
      }
    } catch (error) {
      console.log(error);
      setLoading('error');
    }
  };

  // ----------------------------------------------------

  const previewAssessment = () => {
    navigate(QPG_PREVIEW);
  };

  // ----------------------------------------------------

  const backButtonClick = () => {
    navigate(ASSESMENT_LIBRARY, { state: { fromQPGPublished: true } });
  };
  useEffect(() => {
    setSelectedFunction(() => backButtonClick);
    return () => {
      setSelectedFunction(null);
    };
  }, []);

  useEffect(() => {
    if (assessmentId) {
      fetchAssessmentContent();
    }
  }, [assessmentId]);

  // ----------------------------------------------------

  if (loading === 'loading') return <Loader />;

  if (loading === 'error')
    return (
      <NoContentCard
        variant="error"
        icon="error"
        text="Error Occurred While Fetching Question Paper Details"
      />
    );

  return (
    <Box sx={styles.root}>
      {isDownloading && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(255,255,255,0.8)',
          }}
        >
          <Loader />
        </Box>
      )}

      <QPGPrintablePaper
        printAnswer={printAnswer}
        ref={printablePaperRef}
        printableFontSize={printFontSize}
        SchoolLogo={school_logo_url}
      />
      <Box sx={styles.mainHeadingBox}>
        <Typography variant="h1" sx={styles.ellipsisText}>
          {qpg_content?.assessment?.assessmentTitle}
        </Typography>
        <Box sx={styles.viewAndPdfBox}>
          <Button
            sx={styles.settingsbox}
            onClick={() => setAddFontSizePopup(true)}
          >
            <ImageWrapper
              name="setting"
              parentFolder="icons"
              type="png"
              styles={{
                width: { xs: pxToRem(10), md: pxTovW(18) },
                height: { xs: pxToRem(10), md: pxTovW(18) },
              }}
            />
          </Button>
        </Box>
        <Box sx={styles.viewAndPdfBox}>
          <Button onClick={previewAssessment} sx={styles.previewBox}>
            <ImageWrapper
              name="eye-yellow"
              parentFolder="icons"
              type="png"
              styles={{
                width: { xs: pxToRem(15), md: pxTovW(24) },
                height: { xs: pxToRem(10), md: pxTovW(18) },
              }}
            />
          </Button>

          <Button sx={styles.viewLibraryButton} onClick={viewLibraryHandler}>
            <AddCircleOutlineIcon
              sx={{
                color: '#0AA34F',
                fontSize: { xs: pxToRem(18), md: pxTovW(30) },
              }}
            />
            <Typography
              variant="h5"
              fontWeight="bold"
              color="secondary.main"
              sx={{ fontFamily: 'Poppins' }}
            >
              View Library
            </Typography>
          </Button>

          <Button sx={styles.downloadPdfButton} onClick={handleMenuClick}>
            <IconWrapper
              name="download-qpg-blue"
              type="png"
              parentFolder="icons"
              size="md"
            />
            <Typography
              variant="h5"
              fontWeight="bold"
              color="primary.main"
              sx={{ fontFamily: 'Poppins' }}
            >
              Download PDF
            </Typography>
          </Button>
        </Box>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          onClick={(e) => e.stopPropagation()}
          sx={styles.menu}
        >
          {menuItems.map((item, index) => (
            <MenuItem
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                handleMenuClose();
                item.onClick();
              }}
              sx={styles.menuItem}
            >
              <Typography
                variant="smallText"
                fontWeight="regular"
                sx={{ fontFamily: 'Poppins' }}
              >
                {item.name}
              </Typography>
            </MenuItem>
          ))}
        </Menu>
      </Box>

      <Box sx={styles.publishedCreateCopyBox}>
        <Box sx={styles.publishedAndNoteBox}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Box sx={styles.publishedBox}>
              <IconWrapper
                name="green-circle-check"
                parentFolder="icons"
                type="png"
                size="large"
              />

              <Typography variant="h3" fontWeight="bold" color="secondary.main">
                Published
              </Typography>
            </Box>

            {isMobile ? (
              <PrimaryButton
                variant="contained"
                color="secondary"
                onClick={createCopyHandler}
                sx={styles.createCopyButton}
              >
                <IconWrapper
                  name="copy-sheets"
                  parentFolder="icons"
                  type="png"
                  size="md"
                  customSx={{
                    width: { xs: pxToRem(12), md: 'unset' },
                    height: { xs: pxToRem(12), md: 'unset' },
                  }}
                />

                <Typography
                  variant="smallText"
                  fontWeight="medium"
                  color="white"
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { xs: pxToRem(9), md: 'unset' },
                  }}
                >
                  Create Copy
                </Typography>
              </PrimaryButton>
            ) : null}
          </Box>

          <Typography
            variant="smallText"
            fontWeight="regular"
            sx={{ fontFamily: 'Poppins' }}
          >
            Note: Published assessments cannot be edited. Create copy to make
            changes.
          </Typography>
        </Box>

        {isMobile ? null : (
          <PrimaryButton
            variant="contained"
            color="secondary"
            onClick={createCopyHandler}
            sx={styles.createCopyButton}
          >
            <IconWrapper
              name="copy-sheets"
              parentFolder="icons"
              type="png"
              size="md"
            />

            <Typography
              variant="smallText"
              fontWeight="medium"
              color="white"
              sx={{ fontFamily: 'Poppins' }}
            >
              Create Copy
            </Typography>
          </PrimaryButton>
        )}
      </Box>

      <Box sx={styles.secondaryHeadingBox}>
        <Typography variant={isMobile ? 'h3' : 'h2'} fontWeight="bold">
          Preview Subject Level Assessment
        </Typography>

        <Box sx={styles.classNamePill}>
          <Typography
            variant={isMobile ? 'h3' : 'h2'}
            fontWeight="bold"
            color="primary"
          >
            Class {qpg_content?.assessment?.class}
          </Typography>
        </Box>
      </Box>

      <Box sx={styles.cardsBox}>
        {qpg_content?.multiSubjectSections.map((item, index) => (
          <PaperDetailsCard
            subjectIcon={getSubjectImageBySubjectId(
              item.subjectId,
              user_info?.teachClassSubjects
            )}
            subjectColor={getSubjectColorBySubjectId(
              item.subjectId,
              user_info?.teachClassSubjects
            )}
            subjectName={getSubjectNameFromEnum(item.subject)}
            marks={getTotalMarksOfSection(item)}
            reorderCardHandler={() => {}}
            deleteCardHandler={() => {}}
            onChangeSectionTitle={() => {}}
            createAssessmentHandler={() => {}}
            sectionTitle={item.sectionTitle}
            chapterList={item.chapterInfo?.chapterTopicsInfo}
            noOfQuestions={item.numberOfQuestion}
            difficultyLevel={getDifficultyLevelString(item.avgDifficultyLevel)}
            assessmentStatus={item.multiSubjectSectionStatus}
            published={true}
          />
        ))}
      </Box>
      <ReminderPopup
        iconName="setting"
        heading={<Typography variant="h2">PDF font size</Typography>}
        open={addFontSizePopup}
        handleClose={() =>
          printFontSize > 8 && printFontSize < 20
            ? setAddFontSizePopup(false)
            : dispatch(
                setToastInfoV2({
                  label: 'Font size must be between 8 and 20',
                  variant: 'error',
                  open: true,
                })
              )
        }
        popupComponent={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: pxToRem(10), md: pxTovW(20) },
              padding: { xs: pxToRem(10), md: pxTovW(10) },
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Box
              sx={{ width: '100%', justifyContent: 'center', display: 'flex' }}
            >
              <Box
                sx={{
                  marginTop: {
                    xs: pxToRem(10),
                    md: pxTovW(15),
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                  },
                }}
              >
                <InputField
                  variant="outlined"
                  placeholder="Enter font size"
                  type="number"
                  value={printFontSize?.toString() || ''}
                  inputProps={{
                    min: 8,
                    max: 20,
                  }}
                  onChange={(e) => {
                    setPrintFontSize(Number(e.target.value));
                  }}
                  sx={{
                    width: '70%',
                  }}
                />
              </Box>
            </Box>

            <Button
              variant="contained"
              onClick={() =>
                printFontSize >= 8 && printFontSize <= 20
                  ? setAddFontSizePopup(false)
                  : dispatch(
                      setToastInfoV2({
                        label: 'Font size must be between 8 and 20',
                        variant: 'error',
                        open: true,
                      })
                    )
              }
              sx={{
                backgroundColor: '#007CDC',
                width: { xs: '100%', md: '50%' },
              }}
            >
              Save
            </Button>
          </Box>
        }
      />
    </Box>
  );
};

// =====================================================
